import { render, staticRenderFns } from "./mail_login.vue?vue&type=template&id=9507f8e4&scoped=true"
import script from "./mail_login.vue?vue&type=script&lang=js"
export * from "./mail_login.vue?vue&type=script&lang=js"
import style0 from "./mail_login.vue?vue&type=style&index=0&id=9507f8e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9507f8e4",
  null
  
)

export default component.exports